import * as React from "react";
import { useCallback, useMemo, useState } from "react";
import InputSetupWizardContext from "components/inputs/InputSetupWizard/contexts/InputSetupWizardContext";
import { INPUT_WIZARD_FLOWS } from "components/inputs/InputSetupWizard/types";
import { getNextStep, checkHasPreviousStep } from "components/inputs/InputSetupWizard/helpers/stepHelper";
const DEFAULT_ACTIVE_STEP = void 0;
const DEFAULT_WIZARD_DATA = {
  flow: INPUT_WIZARD_FLOWS.NON_ILLUMINATE
};
const InputSetupWizardProvider = ({ children = null }) => {
  const [activeStep, setActiveStep] = useState(DEFAULT_ACTIVE_STEP);
  const [wizardData, setWizardData] = useState(DEFAULT_WIZARD_DATA);
  const [orderedSteps, setOrderedSteps] = useState([]);
  const goToNextStep = useCallback(() => {
    const nextStep = getNextStep(orderedSteps, activeStep);
    if (!nextStep) return;
    const nextStepIndex = orderedSteps.indexOf(nextStep);
    setActiveStep(orderedSteps[nextStepIndex]);
  }, [activeStep, orderedSteps]);
  const goToPreviousStep = useCallback(() => {
    if (!checkHasPreviousStep(orderedSteps, activeStep)) return;
    const previousStepIndex = orderedSteps.indexOf(activeStep) - 1;
    setActiveStep(orderedSteps[previousStepIndex]);
  }, [activeStep, orderedSteps]);
  const value = useMemo(
    () => ({
      setActiveStep,
      activeStep,
      wizardData,
      setWizardData,
      orderedSteps,
      setOrderedSteps,
      goToPreviousStep,
      goToNextStep
    }),
    [activeStep, wizardData, orderedSteps, goToPreviousStep, goToNextStep]
  );
  return /* @__PURE__ */ React.createElement(InputSetupWizardContext.Provider, { value }, children);
};
export default InputSetupWizardProvider;
